export default {
  dark: 'Dark',
  light: 'Light',
};
